import { ISSUE_FIELD_OBJECT_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import { transformAggNodeToLegacyField } from './default-node-transformer.tsx';
import isFieldMissingRenderer from './helpers/is-field-missing-renderer.tsx';

export const transformAggForgeObjectToLegacyField: FieldTransformer = (node) => {
	if (isFieldMissingRenderer(node)) {
		return undefined;
	}

	const value = (() => {
		if (node.object == null) return null;
		try {
			return JSON.parse(node.object);
		} catch (e) {
			throw new Error(
				'Failed to transform forge object field: node.object was invalid JSON object',
			);
		}
	})();

	return {
		...transformAggNodeToLegacyField(node),
		value,
		schema: {
			configuration: null,
			items: null,
			system: null,
			custom: node.type,
			renderer: node.renderer,
			type: ISSUE_FIELD_OBJECT_CF_TYPE,
		},
	};
};
